import { BUILDER_DEVICE_TAB } from './templateBuilderTabs';
import {
  APPLE_ENHANCED_DESIGN_IMAGES_NAMESPACE,
  APPLE_ENHANCED_DESIGN_FEATURED_ACTIONS_NAMESPACE,
  ENHANCED_EVENT_TICKET_SECTION_ID,
  FEATURED_ACTIONS_SECTION_ID,
} from './appleEnhancedDesignConstants';

export const ARTWORK_ERROR_PREFIX = `${APPLE_ENHANCED_DESIGN_IMAGES_NAMESPACE}.artwork`;

export const sectionHasErrorsForId = (
  id: string | undefined,
  errorKeys: string[],
  selectedTab?: string
): boolean => {
  if (!id) return false;

  switch (id) {
    case 'template-details-section':
      return errorKeys.some(
        (key) =>
          key === 'templateName' ||
          key === 'description' ||
          key === 'centralTitle' ||
          key === 'transitType'
      );
    case 'notifications-section':
      return errorKeys.includes('notificationHeader');
    case 'design-section':
      return errorKeys.some(
        (key) =>
          key.startsWith('images.') ||
          key.includes('colors') ||
          key.startsWith(ARTWORK_ERROR_PREFIX)
      );
    case 'fields-section':
      return errorKeys.some((key) => key.includes('fields'));
    case 'form-fields-section':
      return errorKeys.some((key) => key.startsWith('form.formFields'));
    case 'custom-query-parameters-section':
      return errorKeys.some((key) => key.includes('form.queryParams'));
    case 'app-linking-section':
      if (selectedTab === BUILDER_DEVICE_TAB.APPLE) {
        return errorKeys.some(
          (key) =>
            key.startsWith('appLinking.appleAppStoreUrl') ||
            key === 'appLinking.appleAppStoreUrl'
        );
      } else if (selectedTab === BUILDER_DEVICE_TAB.GOOGLE) {
        return errorKeys.some(
          (key) =>
            key === 'appLinking.googleAppPlayStoreUrl' ||
            key === 'appLinking.googleAppPackageName' ||
            key === 'appLinking.googleWebUrl' ||
            key === 'appLinking.googleDisplayText'
        );
      }
      return errorKeys.some((key) => key.includes('appLinking'));
    case 'beacons-section':
      return errorKeys.some((key) => key.includes('beacons'));
    case 'locations-section':
      return errorKeys.some((key) => key.includes('locations'));
    case ENHANCED_EVENT_TICKET_SECTION_ID:
      return errorKeys.some(
        (key) =>
          key.startsWith('appleEnhancedDesign') &&
          !key.startsWith(ARTWORK_ERROR_PREFIX) &&
          !key.startsWith(APPLE_ENHANCED_DESIGN_FEATURED_ACTIONS_NAMESPACE)
      );
    case FEATURED_ACTIONS_SECTION_ID:
      return errorKeys.some((key) =>
        key.startsWith(APPLE_ENHANCED_DESIGN_FEATURED_ACTIONS_NAMESPACE)
      );
    default:
      return false;
  }
};
